import { TextInput } from '@kcftech/design-system';
import {
    getMaxValueRules,
    getMinValueRules,
    getNumericValueRules,
} from 'pages/Settings/AssemblyType/parameter_form/shared';
import { MinMaxInputContainer } from 'pages/Settings/AssemblyType/parameter_form/styled';
import {
    AssemblyParameterFormInputProps,
    typeGuardAssemblyParameterForm,
} from 'pages/Settings/AssemblyType/parameter_form/types';
import { useEffect, useMemo } from 'react';

export function AssemblyParameterIntegerFormContent({
    form: _form,
}: AssemblyParameterFormInputProps) {
    const form = typeGuardAssemblyParameterForm(_form, 'integer');

    const {
        register,
        trigger,
        watch,
        formState: { errors },
    } = form;

    const { type, minValue, maxValue } = watch();

    const minValueRules = useMemo(
        () => ({ ...getMinValueRules(type, maxValue), deps: ['maxValue', 'type'] }),
        [maxValue, type]
    );

    const maxValueRules = useMemo(
        () => ({ ...getMaxValueRules(type, minValue), deps: ['minValue', 'type'] }),
        [minValue, type]
    );

    const defaultValueRules = useMemo(
        () =>
            getNumericValueRules({
                type,
                fieldName: 'Default Value',
                minValue,
                maxValue,
                minValueInclusive: undefined,
                maxValueInclusive: undefined,
            }),
        [maxValue, minValue, type]
    );

    useEffect(() => {
        trigger('defaultValue');
    }, [minValue, maxValue, trigger]);

    return (
        <>
            <MinMaxInputContainer>
                <TextInput
                    ariaLabel="min value"
                    label="Min Value"
                    placeholder="Enter a minimum value"
                    error={errors.minValue?.message}
                    width="26rem"
                    {...register('minValue', minValueRules)}
                />

                <TextInput
                    ariaLabel="max value"
                    label="Max Value"
                    placeholder="Enter a maximum value"
                    error={errors.maxValue?.message}
                    width="26rem"
                    {...register('maxValue', maxValueRules)}
                />
            </MinMaxInputContainer>

            <TextInput
                ariaLabel="default value"
                label="Default Value"
                placeholder="Enter a default value"
                error={errors.defaultValue?.message}
                {...register('defaultValue', defaultValueRules)}
            />
        </>
    );
}
